import * as apiTpaRequest from '@/network/api/tpaRequest.api.js'
import * as apiTpaRequestLovs from '@/network/api/tpaRequestLovs.api.js'
import * as apiAccount from '@/network/api/accounts.api.js'
import * as apiLocation from '@/network/api/location.api.js'
import * as apiAgencies from '@/network/api/agencies.api.js'
import * as apiBranches from '@/network/api/branches.api.js'

/** requests tpa types
@payload { Object }
@return { promise } - tpa types request
*/
export const requestListTPAsTypesAvailable = async (context, payload) => {
    const res = await apiTpaRequest.getListTPAsTypesAvailableForRequest(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AVAILABLE_TPAS_TYPES', data)
    }
    return res
}

/** validates NIF
@payload { Object }
@return { promise } - validates NIF
*/
export const validatesNIFForTPAsRequest = async (context, payload) => {
    const res = await apiTpaRequest.validatesNIFForTPAsRequest(payload)
    return res
}

/** requests Accounts Balance
@return { promise } - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await apiAccount.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests company data
@return { promise } - Company Data request
*/
export const requestCompanyData = async (context, payload) => {
    const res = await apiTpaRequest.getCompanyDataForTPAsRequest(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_COMPANY_DATA', data)
    }
    return res
}

/** requests locations
@return { promise } - Locations request
*/
export const requestLocations = async (context, payload) => {
    const res = await apiLocation.getListEconomicActivities(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_LOCATIONS', data)
    }
    return res
}

/** requests agencies provinces
@return { promise } - Agencies Provinces request
*/
export const requestAgenciesProvinces = async (context, payload) => {
    const res = await apiAgencies.requestAgenciesProvinces(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AGENCIES_PROVINCES', data)
    }
    return res
}

/** requests branches
@return { promise } - Branches list request
*/
export const requestBranches = async (context, payload) => {
    const res = await apiBranches.requestBranchesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_BRANCHES', data)
    }
    return res
}

/** requests economic activities
@return { promise } - Economic Activities request
*/
export const requestEconomicActivities = async (context, payload) => {
    const res = await apiTpaRequestLovs.getListEconomicActivities(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ECONOMIC_ACTIVITIES', data)
    }
    return res
}

/** requests authorized operations
@return { promise } - Authorized Operations request
*/
export const requestAuthorizedOperations = async (context, payload) => {
    const res = await apiTpaRequestLovs.getListAuthorizedOperations(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AUTHORIZED_OPERATIONS', data)
    }
    return res
}

/** requests accepted cards
@return { promise } - Accepted Cards request
*/
export const requestAcceptedCards = async (context, payload) => {
    const res = await apiTpaRequestLovs.getListAcceptedCards(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCEPTED_CARDS', data)
    }
    return res
}

/** validates amount
@return { promise } - validates amount request
*/
export const validateAmount = async (context, payload) => {
    const res = await apiTpaRequest.validatesAmountForTPAsRequest(payload)

    return res
}

/** calculates taxes
@return { promise } - calculates taxes request
*/
export const calculatesTaxes = async (context, payload) => {
    const res = await apiTpaRequest.calculatesTaxesForTPAsRequest(payload)

    return res
}

/** Pay Emis Reference
@return { promise }
*/
export const tpaRequestSubmit = async (context, payload) => {
    const res = await apiTpaRequest.submitTPAsRequest(payload)
    return res
}
/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
/** Clear Request TPAs BAI Feature States
@return { promise }
*/
export const clearRequestTPAsBAIFeatureState = async (context, payload) => {
    context.commit('CLEAR_REQUEST_TPAS_BAI_FEATURE_STATE')
}
